import { Component, ElementRef, HostListener, OnInit, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { faBell, faUser } from '@fortawesome/free-regular-svg-icons';
import { GlobalDataService } from '../shared/services/global-data.service';
import { filter } from 'rxjs/operators';
import { ConfigService, SystemConfig } from '../shared/services/config.service';
import { MatDialog } from '@angular/material/dialog';
import { NotificationComponent } from '../notification/notification.component';
import { ReferralNotificationService } from '../shared/services/referral-notification.service';
import { ReferralContact } from '../shared/models/referral-contacts';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationService } from '../shared/services/navigation.service';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { SnackbarService } from '../shared/services/snackbar.service';
import { UserDetails } from '../shared/models/user-details';
import { AuthService } from '../shared/services/auth.service';
import { ViewEncapsulation } from '@angular/compiler';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss']
})

export class NavMenuComponent implements OnInit {
    faUser = faUser;
    faBell = faBell;
    userDisplayName: string = ""
    userId: number | undefined;
    menuOpen = false;
    system: string = "";
    hasNotifications = false;
    isIdVerificationTab = false;
    referralContacts: ReferralContact[] = [];
    readonly dialog = inject(MatDialog);
    showTabs: boolean = true;
    private readonly elementRef = inject(ElementRef);
    public faSignOutAlt = faSignOutAlt;
    userDetails: UserDetails | null = null
    isDropdownOpen = false;
    constructor(
        private router: Router,
        public globalDataSharing: GlobalDataService,
        private configService: ConfigService,
        private referralNotificationService: ReferralNotificationService,
        private snackBar: SnackbarService,
        public navService: NavigationService,
        public authService: AuthService
    ) {
        globalDataSharing.currentTab = "IdVerification"
    }

    ngOnInit(): void {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.updateTabFromUrl();
        });
        this.updateTabFromUrl();
        this.loadSystemConfig();
    }

    toggleDropdown(): void {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    closeDropdown(): void {
        this.isDropdownOpen = false;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        const targetElement = event.target as HTMLElement;

        if (this.isDropdownOpen && !this.elementRef.nativeElement.contains(targetElement)) {
            this.isDropdownOpen = false;
        }
    }

    loadSystemConfig() {
        this.configService.getSystemConfig().subscribe(
            (config: SystemConfig) => {
                this.system = config.system;
            },
            error => {
                console.error('Error loading system config:', error);
            }
        );
    }

    logout() {
        sessionStorage.clear()
        window.location.replace('/home');
    }

    selectTab(selectedTab: string) {
        this.globalDataSharing.currentTab = selectedTab;
        if (selectedTab === 'IdVerification') {
            this.isIdVerificationTab = true;
            this.router.navigate(['/idverification']);
        }
    }

    updateTabFromUrl() {
        const url = this.router.url;
        if (url.includes('idverification')) {
            this.isIdVerificationTab = true;
            this.globalDataSharing.currentTab = 'IdVerification';
            var userDetails = sessionStorage.getItem("user-details");
            if (userDetails) {
                this.getReferredContacts();
            }
        }
        else if (url.includes('admin')) {
            this.showTabs = false;
        }
    }

    getReferredContacts() {
        this.referralNotificationService.getReferredContacts().subscribe(
            res => {
                this.referralContacts = res || [];
                this.hasNotifications = this.referralContacts.length > 0;
            },
            error => {
                this.snackBar.errorSnackBar(error.error.errors[0].message);
                this.referralContacts = [];
                this.hasNotifications = false;
            }
        )
    }

    displayContact() {
        this.dialog.open(NotificationComponent, {
            height: '700px',
            maxHeight: '700px',
            width: '900px',
            maxWidth: '900px',
            panelClass: 'full-screen-modal',
            disableClose: true
        });
    }

    navigateToConf() {
        this.router.navigate(['/admin']);
    }

}
